import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { useDrawerContext } from "./drawer";

export interface DrawerFooterProps
  extends React.HTMLAttributes<HTMLDivElement> {}

export default function DrawerFooter(props: Readonly<DrawerFooterProps>) {
  const { className, children, ...rest } = props;
  const { open, float } = useDrawerContext();

  return (
    <div
      {...rest}
      className={twMerge(
        clsx("sticky bottom-0 left-0 bg-secondary-dark !pt-0", {
          "p-3": open || float,
          "p-2": !open && !float,
        }),
        className
      )}
    >
      {children}
    </div>
  );
}
